var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7918 1.21424C11.1935 -0.384084 9.62817 -0.425277 7.98867 1.21424L6.99179 2.21113C6.90941 2.29352 6.87645 2.42534 6.90941 2.54068C7.53555 4.72395 9.28215 6.47057 11.4654 7.09672C11.4984 7.10496 11.5313 7.1132 11.5643 7.1132C11.6549 7.1132 11.7373 7.08024 11.8032 7.01433L12.7918 6.01744C13.6075 5.21004 14.0029 4.42736 14.0029 3.63644C14.0112 2.8208 13.6157 2.02988 12.7918 1.21424Z",
    fill: "#0195D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98214 7.84492C9.74322 7.72958 9.51254 7.61424 9.29009 7.48242C9.10884 7.37531 8.93583 7.25997 8.76282 7.13639C8.62276 7.04576 8.45799 6.91394 8.30145 6.78212C8.28497 6.77388 8.2273 6.72445 8.16139 6.65854C7.88952 6.42786 7.58468 6.13126 7.31281 5.80171C7.28809 5.78523 7.2469 5.72756 7.18923 5.65341C7.10684 5.55455 6.96678 5.38977 6.8432 5.20028C6.74434 5.0767 6.629 4.89544 6.52189 4.71419C6.39007 4.49174 6.27473 4.2693 6.15939 4.03861C6.00816 3.71455 5.58284 3.61828 5.32997 3.87115L0.69714 8.50403C0.590037 8.61113 0.491173 8.8171 0.466457 8.95716L0.0215673 12.1126C-0.0608196 12.6728 0.0957158 13.2001 0.441741 13.5544C0.738334 13.8427 1.15027 13.9993 1.59516 13.9993C1.69402 13.9993 1.79289 13.991 1.89175 13.9746L5.05541 13.5297C5.2037 13.505 5.40967 13.4061 5.50854 13.299L10.149 8.65847C10.3968 8.41065 10.3037 7.98427 9.98214 7.84492Z",
    fill: "#0195D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.328172db5e8cc24cd9de0e27eedd4954.svg";
export { ForwardRef as ReactComponent };